import { useCallback } from "react"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import {
  Ch_deleteBodyMeasurementInput,
  chDeleteBodyMeasurementMutation,
} from "@/modules/patients/services/ch/__generated__/chDeleteBodyMeasurementMutation.graphql"
import { chDeleteBodyMeasurementMutation as chMutation } from "@/modules/patients/services/ch/chDeleteBodyMeasurementMutation"
import {
  De_deleteBodyMeasurementInput,
  deDeleteBodyMeasurementMutation,
} from "@/modules/patients/services/de/__generated__/deDeleteBodyMeasurementMutation.graphql"
import { deDeleteBodyMeasurementMutation as deMutation } from "@/modules/patients/services/de/deDeleteBodyMeasurementMutation"

export const useDeleteBodyMeasurement = (country: Country) => {
  const mutation = country === "CH" ? chMutation : deMutation

  const [commit] = useMutationWithErrorDialog<chDeleteBodyMeasurementMutation & deDeleteBodyMeasurementMutation>(
    mutation,
  )

  return useCallback(
    (
      input: De_deleteBodyMeasurementInput & Ch_deleteBodyMeasurementInput,
      connectionID: string,
      onCompleted?: () => void,
    ) => {
      commit({
        variables: {
          input,
          connections: [connectionID],
        },
        onCompleted(response) {
          const data = response.deleteBodyMeasurement
          if (!data.errors?.length) {
            onCompleted?.()
          }
        },
      })
    },
    [commit],
  )
}
